/**
 *  Converts an engage sciences boolean ('on', 'off') to javascript bool
 *  @param value - the 'on'/'off' value to resolve
 *
 */
const resolveBoolean = val => {
  if (val === true || val === false) {
    return val;
  }
  return val === 'on' || val === 'true' ? true : false;
};

export { resolveBoolean };
